let cachedSimdSupport = null;

const simdModuleBytes = new Uint8Array([
  0x00, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00,
  0x01, 0x05, 0x01, 0x60, 0x00, 0x01, 0x7b,
  0x03, 0x02, 0x01, 0x00,
  0x0a, 0x17, 0x01, 0x14, 0x00, 0xfd, 0x0c,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x0b
]);

export const detectWasmSimdSupport = async () => {
  if (cachedSimdSupport !== null) return cachedSimdSupport;
  try {
    cachedSimdSupport = WebAssembly.validate(simdModuleBytes);
  } catch (_) {
    cachedSimdSupport = false;
  }
  return cachedSimdSupport;
};

export const getCachedWasmSimdSupport = () => cachedSimdSupport;
